import { formatCurrency } from '@/app/utils/formatCurrency';
import { formatIsoDateOnlyShort } from '@/app/utils/formatDate';
import type { ThirdPartyVehicle } from '../types/thirdPartyAgreement.types';

export const thirdPartyStartDateText = (startDate: string | null): string =>
    startDate ? formatIsoDateOnlyShort(startDate) : '—';

export const thirdPartyBalanceText = (minor: number | null): string | null =>
    minor === null ? null : formatCurrency(minor / 100);

export const thirdPartyMakeModel = (vehicle: ThirdPartyVehicle): string | undefined =>
    [vehicle.make, vehicle.model].filter(Boolean).join(' ') || undefined;
